/**
 * Service Gallery JavaScript
 * Handles lightbox functionality for service gallery images
 */

class ServiceGallery {
  constructor() {
    this.galleries = document.querySelectorAll('.service-gallery');
    this.lightboxModal = null;
    this.currentImageIndex = 0;
    this.currentGalleryImages = [];
    
    this.init();
  }
  
  init() {
    if (this.galleries.length === 0) return;
    
    this.createLightboxModal();
    this.bindEvents();
  }
  
  createLightboxModal() {
    // Create modal HTML with navigation
    const modalHTML = `
      <div class="service-lightbox-modal" id="serviceLightboxModal" style="display: none;">
        <button class="service-lightbox-close">&times;</button>
        <button class="service-lightbox-prev">‹</button>
        <button class="service-lightbox-next">›</button>
        <div class="service-lightbox-content">
          <img class="service-lightbox-image" src="" alt="">
          <div class="service-lightbox-title"></div>
          <div class="service-lightbox-counter">
            <span class="service-lightbox-current">1</span> / <span class="service-lightbox-total">10</span>
          </div>
        </div>
      </div>
    `;
    
    // Add modal to DOM
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.lightboxModal = document.getElementById('serviceLightboxModal');
  }
  
  // Styles are now in CSS file
  
  bindEvents() {
    // Bind click events to gallery links
    this.galleries.forEach(gallery => {
      const links = gallery.querySelectorAll('[rel="images_gallery"]');
      links.forEach((link, index) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox(gallery, index);
        });
      });
    });
    
    // Bind lightbox controls
    if (this.lightboxModal) {
      this.lightboxModal.querySelector('.service-lightbox-close').addEventListener('click', () => {
        this.closeLightbox();
      });
      
      this.lightboxModal.querySelector('.service-lightbox-prev').addEventListener('click', () => {
        this.prevImage();
      });
      
      this.lightboxModal.querySelector('.service-lightbox-next').addEventListener('click', () => {
        this.nextImage();
      });
      
      // Click modal background to close
      this.lightboxModal.addEventListener('click', (e) => {
        if (e.target === this.lightboxModal) {
          this.closeLightbox();
        }
      });
      
      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!this.lightboxModal.classList.contains('active')) return;
        
        switch(e.key) {
          case 'Escape':
            this.closeLightbox();
            break;
          case 'ArrowLeft':
            this.prevImage();
            break;
          case 'ArrowRight':
            this.nextImage();
            break;
        }
      });
    }
  }
  
  openLightbox(gallery, startIndex) {
    const links = gallery.querySelectorAll('[rel="images_gallery"]');
    this.currentGalleryImages = Array.from(links);
    this.currentImageIndex = startIndex;
    
    this.showCurrentImage();
    this.lightboxModal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scroll
  }
  
  closeLightbox() {
    this.lightboxModal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scroll
  }
  
  showCurrentImage() {
    const currentLink = this.currentGalleryImages[this.currentImageIndex];
    const imgSrc = currentLink.href;
    const imgTitle = currentLink.title || '';
    
    const lightboxImage = this.lightboxModal.querySelector('.service-lightbox-image');
    const lightboxTitle = this.lightboxModal.querySelector('.service-lightbox-title');
    const currentSpan = this.lightboxModal.querySelector('.service-lightbox-current');
    const totalSpan = this.lightboxModal.querySelector('.service-lightbox-total');
    
    lightboxImage.src = imgSrc;
    lightboxImage.alt = imgTitle;
    lightboxTitle.textContent = imgTitle;
    currentSpan.textContent = this.currentImageIndex + 1;
    totalSpan.textContent = this.currentGalleryImages.length;
    
    // Show/hide navigation buttons
    const prevBtn = this.lightboxModal.querySelector('.service-lightbox-prev');
    const nextBtn = this.lightboxModal.querySelector('.service-lightbox-next');
    
    prevBtn.style.display = this.currentImageIndex > 0 ? 'block' : 'none';
    nextBtn.style.display = this.currentImageIndex < this.currentGalleryImages.length - 1 ? 'block' : 'none';
  }
  
  prevImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.showCurrentImage();
    }
  }
  
  nextImage() {
    if (this.currentImageIndex < this.currentGalleryImages.length - 1) {
      this.currentImageIndex++;
      this.showCurrentImage();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ServiceGallery();
});

// Handle dynamic content loading (e.g., AJAX)
if (typeof window.Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', () => {
    new ServiceGallery();
  });
}
